import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './styles/global.css';
import Header from './components/header';
import Footer from './components/footer';
import QuizHub from './pages/QuizHub';
import QuizPage from './pages/QuizPage';
import ResultLoadingPage from './pages/ResultLoadingPage';
import ResultPage from './pages/ResultPage';

function QuizLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header />
      <div className="content">{children}</div>
    </>
  );
}

function HubLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header />
      <div className="content">{children}</div>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          {/* Hub */}
          <Route path="/" element={<HubLayout><QuizHub /></HubLayout>} />

          {/* Quiz routes */}
          <Route path="/quiz/:quizId" element={<QuizLayout><QuizPage /></QuizLayout>} />
          <Route path="/quiz/:quizId/loading" element={<QuizLayout><ResultLoadingPage /></QuizLayout>} />
          <Route path="/quiz/:quizId/result" element={<QuizLayout><ResultPage /></QuizLayout>} />

          {/* Legacy redirects */}
          <Route path="/question" element={<Navigate to="/quiz/life-expectancy" replace />} />
          <Route path="/result" element={<Navigate to="/quiz/life-expectancy/result" replace />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
